/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';
import { FormattedMessage } from 'react-intl-next';

import type {
	AssociationEdge,
	AssociationEdgeEntity,
	ThirdPartyUser,
} from '@atlassian/dynamic-cards-search-client';

import { messages } from './messages';

/**
 * The whitespace in between aliases <!here> <!channel> is removed
 * This constant prevent the alias from being pushed together ex: "@here@channel"
 * We are using this constant rather than adding a space through CSS because it adds
 * a real space character that does not break up the text when selecting.
 * */
const SPACE = ' ';

interface MentionProps {
	children?: string | string[] | JSX.Element | undefined;
}

export const Mention = ({ children }: MentionProps) => {
	return (
		<span>
			{SPACE}@{children}
		</span>
	);
};

interface UserMentionProps {
	associations?: AssociationEdge<AssociationEdgeEntity>[];
	children?: string[];
}

export const UserMention = ({ children, associations }: UserMentionProps) => {
	const channelId = children?.[0];
	const userAssociation = associations?.find(
		(edge): edge is AssociationEdge<ThirdPartyUser> =>
			Boolean(channelId) && channelId === edge?.node?.entity?.externalId,
	);

	const name = userAssociation?.node?.entity?.name || (
		<FormattedMessage {...messages.externalPersonLabel} />
	);
	if (!name) {
		return null;
	}

	return <Mention>{name}</Mention>;
};
